import { useState } from 'react';
import { goi, LoiApi, tien } from '../chung/api';
import { useHoiLai } from '../chung/hoi-lai';
import type { GiamGia, KieuGiam, NhomSanPham, PhamViGiam } from '../chung/kieu';
import { DaiLoi, DaiTot, HopHoi, Khung, O } from './manh';

/**
 * Giảm giá.
 *
 * 🔴 KHÔNG có ô "nhập mã giảm giá" ở bất kỳ đâu — chốt từ lượt 1. Hệ thống tự
 *    áp ưu đãi tốt nhất. Giảm giá là tiền; cho nhân viên tự áp thì không kiểm
 *    soát được, và sẽ thành chỗ để lách.
 *
 * 🔴 Tạo xong thì KHÔNG sửa được kiểu · giá trị · phạm vi · đối tượng nhắm.
 *
 *    Đơn cũ đã chụp lại `discountId` và số tiền. Sửa giá trị của một ưu đãi đã
 *    dùng thì sáu tháng sau nhìn đơn cũ thấy "giảm 50k theo chương trình X", mở
 *    X ra lại thấy 20% — không khớp, và không ai biết cái nào đúng.
 *
 *    Nên form tạo phải nói rõ điều đó TRƯỚC khi bấm, không phải báo lỗi sau.
 */
export function MucGiamGia() {
  const [caDaTat, datCaDaTat] = useState(true);
  const ds = useHoiLai<GiamGia[]>(`/api/giam-gia${caDaTat ? '?ca_da_tat=true' : ''}`, 20_000);
  const nhom = useHoiLai<NhomSanPham[]>('/api/nhom', 60_000);

  const [tot, datTot] = useState<string | null>(null);
  const [taoMoi, datTaoMoi] = useState(false);
  const [sua, datSua] = useState<GiamGia | null>(null);

  const list = ds.duLieu ?? [];

  return (
    <Khung
      tieuDe="Giảm giá"
      phu={
        ds.duLieu
          ? `${list.filter((d) => d.dang_chay).length} đang chạy · ${list.length} chương trình`
          : 'Đang tải…'
      }
      hanhDong={
        <>
          <button
            onClick={() => datCaDaTat((c) => !c)}
            className={caDaTat ? 'lom-nho' : undefined}
            style={{ color: caDaTat ? 'var(--nhan)' : undefined }}
          >
            Cả cái đã tắt
          </button>
          <button className="nut-chinh" onClick={() => datTaoMoi(true)}>
            + Tạo chương trình
          </button>
        </>
      }
    >
      <DaiLoi loi={ds.loi} />
      <DaiTot chu={tot} />

      {!ds.duLieu && [0, 1].map((i) => <div key={i} className="xuong" style={{ height: 72, marginBottom: 12 }} />)}

      {ds.duLieu && list.length === 0 && (
        <div style={{ padding: '40px 10px', textAlign: 'center', color: 'var(--chu-3)', lineHeight: 1.7 }}>
          Chưa có chương trình nào.
          <br />
          Hệ thống tự áp ưu đãi tốt nhất cho khách — nhân viên không nhập mã.
        </div>
      )}

      {list.map((d, i) => (
        <div
          key={d.id}
          className="noi-nho truot-phai"
          style={{
            animationDelay: `${Math.min(i, 8) * 30}ms`,
            padding: '15px 18px',
            marginBottom: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 16,
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <span style={{ fontWeight: 600 }}>{d.ten}</span>
              {/* `dang_chay` KHÁC `active`: bật rồi vẫn phải trong khoảng ngày. */}
              {d.dang_chay ? (
                <span className="the the-tot">Đang chạy</span>
              ) : d.active ? (
                <span className="the the-cho">Bật, ngoài khoảng ngày</span>
              ) : (
                <span className="the the-mo">Đã tắt</span>
              )}
              <span className="the the-mo">
                {d.pham_vi === 'CA_DON' ? 'Cả đơn' : 'Theo sản phẩm'}
              </span>
            </div>
            <div style={{ fontSize: 12, color: 'var(--chu-3)', marginTop: 5 }}>
              {ngay(d.tu)} → {ngay(d.den)}
              {d.don_toi_thieu ? ` · đơn từ ${tien(d.don_toi_thieu)}` : ''}
            </div>
          </div>
          <span className="tien" style={{ fontSize: 'var(--chu-to)', flexShrink: 0 }}>
            {d.kieu === 'PHAN_TRAM' ? `−${d.gia_tri}%` : `−${tien(d.gia_tri)}`}
          </span>
          <button onClick={() => datSua(d)} style={{ padding: '9px 13px', fontSize: 13, flexShrink: 0 }}>
            Sửa
          </button>
        </div>
      ))}

      {taoMoi && (
        <HopTao
          nhom={nhom.duLieu ?? []}
          dong={() => datTaoMoi(false)}
          xong={(c) => {
            datTaoMoi(false);
            datTot(c);
            ds.taiLai();
          }}
        />
      )}
      {sua && (
        <HopSua
          gg={sua}
          dong={() => datSua(null)}
          xong={(c) => {
            datSua(null);
            datTot(c);
            ds.taiLai();
          }}
        />
      )}
    </Khung>
  );
}

const ngay = (iso: string) => new Date(iso).toLocaleDateString('vi-VN');

/** `<input type="date">` cần `YYYY-MM-DD` theo giờ ĐỊA PHƯƠNG, không phải UTC. */
const nganNgay = (d: Date) => {
  const b = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return b.toISOString().slice(0, 10);
};

// ───────────────────────── tạo ─────────────────────────

function HopTao({ nhom, dong, xong }: { nhom: NhomSanPham[]; dong: () => void; xong: (c: string) => void }) {
  const homNay = new Date();
  const [ten, datTen] = useState('');
  const [kieu, datKieu] = useState<KieuGiam>('PHAN_TRAM');
  const [phamVi, datPhamVi] = useState<PhamViGiam>('SAN_PHAM');
  const [giaTri, datGiaTri] = useState('');
  const [donToiThieu, datDonToiThieu] = useState('');
  const [tu, datTu] = useState(nganNgay(homNay));
  const [den, datDen] = useState(nganNgay(new Date(homNay.getTime() + 30 * 86400000)));
  const [nhomIds, datNhomIds] = useState<number[]>([]);
  const [dangLam, datDangLam] = useState(false);
  const [loi, datLoi] = useState<string | null>(null);

  const gt = Number(giaTri.replace(/[.\s]/g, ''));
  const gtHopLe =
    giaTri.trim() !== '' &&
    Number.isInteger(gt) &&
    (kieu === 'PHAN_TRAM' ? gt >= 1 && gt <= 100 : gt > 0);
  const duoc = ten.trim() !== '' && gtHopLe && tu !== '' && den !== '' && tu <= den;

  const tao = async () => {
    if (!duoc || dangLam) return;
    datDangLam(true);
    datLoi(null);
    try {
      await goi('/api/giam-gia', {
        method: 'POST',
        than: {
          ten: ten.trim(),
          kieu,
          pham_vi: phamVi,
          gia_tri: gt,
          // `don_toi_thieu` CHỈ có nghĩa với CA_DON; gửi kèm ở SAN_PHAM là gieo nhầm.
          ...(phamVi === 'CA_DON' && donToiThieu.trim()
            ? { don_toi_thieu: Number(donToiThieu.replace(/[.\s]/g, '')) }
            : {}),
          tu: new Date(`${tu}T00:00:00`).toISOString(),
          den: new Date(`${den}T23:59:59`).toISOString(),
          ...(phamVi === 'SAN_PHAM' ? { nhom_ids: nhomIds, san_pham_ids: [] } : {}),
        },
      });
      xong(`Đã tạo "${ten.trim()}".`);
    } catch (e) {
      datLoi(e instanceof LoiApi ? e.message : 'Không tạo được.');
      datDangLam(false);
    }
  };

  return (
    <HopHoi tieuDe="Tạo chương trình giảm giá" nutY="TẠO" dangLam={dangLam} dong={dong} dongY={() => void tao()} choPhep={duoc}>
      <DaiLoi loi={loi} />

      {/*
        Cảnh báo đặt TRƯỚC các ô, không đặt cuối. Người ta điền xong rồi mới đọc
        dòng cuối thì đã muộn — mà mấy trường này tạo xong là đông cứng.
      */}
      <div className="lom-nho" style={{ padding: '14px 16px', marginBottom: 20 }}>
        <div style={{ fontWeight: 700, color: 'var(--nhan)', marginBottom: 6 }}>
          Tạo xong không sửa lại được
        </div>
        <div style={{ fontSize: 12, lineHeight: 1.65 }}>
          <b>Kiểu · giá trị · phạm vi · nhóm áp dụng</b> khoá vĩnh viễn. Đơn cũ đã chụp lại số
          tiền đã giảm, sửa ở đây thì đơn cũ và chương trình không khớp nhau nữa.
          <br />
          Muốn đổi thì <b>tắt cái này, tạo cái mới</b>. Sau này chỉ sửa được tên, bật/tắt, và
          ngày kết thúc.
        </div>
      </div>

      <O nhan="Tên chương trình ★">
        <input value={ten} onChange={(e) => datTen(e.target.value)} placeholder="Sale son môi tháng 9" />
      </O>

      <O nhan="Phạm vi ★">
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={() => datPhamVi('SAN_PHAM')}
            className={phamVi === 'SAN_PHAM' ? 'lom-nho' : undefined}
            style={{ flex: 1, padding: 13, fontWeight: 700, color: phamVi === 'SAN_PHAM' ? 'var(--nhan)' : undefined }}
          >
            Theo sản phẩm
          </button>
          <button
            onClick={() => datPhamVi('CA_DON')}
            className={phamVi === 'CA_DON' ? 'lom-nho' : undefined}
            style={{ flex: 1, padding: 13, fontWeight: 700, color: phamVi === 'CA_DON' ? 'var(--nhan)' : undefined }}
          >
            Cả đơn
          </button>
        </div>
      </O>

      <O nhan="Kiểu ★">
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={() => datKieu('PHAN_TRAM')}
            className={kieu === 'PHAN_TRAM' ? 'lom-nho' : undefined}
            style={{ flex: 1, padding: 13, fontWeight: 700, color: kieu === 'PHAN_TRAM' ? 'var(--nhan)' : undefined }}
          >
            Phần trăm
          </button>
          <button
            onClick={() => datKieu('SO_TIEN')}
            className={kieu === 'SO_TIEN' ? 'lom-nho' : undefined}
            style={{ flex: 1, padding: 13, fontWeight: 700, color: kieu === 'SO_TIEN' ? 'var(--nhan)' : undefined }}
          >
            Số tiền
          </button>
        </div>
      </O>

      <O nhan={kieu === 'PHAN_TRAM' ? 'Giảm bao nhiêu % ★ (1–100)' : 'Giảm bao nhiêu đồng ★'}>
        <input value={giaTri} onChange={(e) => datGiaTri(e.target.value)} inputMode="numeric" className="so" />
      </O>

      {phamVi === 'CA_DON' && (
        <O nhan="Đơn tối thiểu (đồng) — để trống là áp cho mọi đơn">
          <input value={donToiThieu} onChange={(e) => datDonToiThieu(e.target.value)} inputMode="numeric" className="so" />
        </O>
      )}

      {phamVi === 'SAN_PHAM' && (
        <O nhan="Nhóm áp dụng — không chọn nhóm nào = áp cho MỌI sản phẩm">
          <div style={{ display: 'flex', gap: 9, flexWrap: 'wrap' }}>
            {nhom.map((n) => {
              const chon = nhomIds.includes(n.id);
              return (
                <button
                  key={n.id}
                  onClick={() =>
                    datNhomIds((c) => (chon ? c.filter((x) => x !== n.id) : [...c, n.id]))
                  }
                  className={chon ? 'lom-nho' : undefined}
                  style={{
                    padding: '8px 15px',
                    fontSize: 13,
                    fontWeight: 600,
                    borderRadius: 'var(--tron)',
                    color: chon ? 'var(--nhan)' : undefined,
                  }}
                >
                  {n.name}
                </button>
              );
            })}
          </div>
        </O>
      )}

      <div style={{ display: 'flex', gap: 14 }}>
        <div style={{ flex: 1 }}>
          <O nhan="Từ ngày ★">
            <input type="date" value={tu} onChange={(e) => datTu(e.target.value)} />
          </O>
        </div>
        <div style={{ flex: 1 }}>
          <O nhan="Đến hết ngày ★">
            <input type="date" value={den} onChange={(e) => datDen(e.target.value)} />
          </O>
        </div>
      </div>

      {tu > den && (
        <div style={{ color: 'var(--nhan)', fontWeight: 600, fontSize: 'var(--chu-nho)' }}>
          Ngày bắt đầu phải trước ngày kết thúc.
        </div>
      )}

      <div style={{ fontSize: 12, color: 'var(--chu-3)', lineHeight: 1.65 }}>
        Hệ thống tính riêng ưu đãi theo sản phẩm và ưu đãi cả đơn, rồi <b>chọn cách giảm được
        nhiều tiền hơn cho khách</b> — không cộng dồn.
      </div>
    </HopHoi>
  );
}

// ───────────────────────── sửa (rất hạn chế) ─────────────────────────

function HopSua({ gg, dong, xong }: { gg: GiamGia; dong: () => void; xong: (c: string) => void }) {
  const [ten, datTen] = useState(gg.ten);
  const [active, datActive] = useState(gg.active);
  const [den, datDen] = useState(nganNgay(new Date(gg.den)));
  const [dangLam, datDangLam] = useState(false);
  const [loi, datLoi] = useState<string | null>(null);

  const luu = async () => {
    if (dangLam || ten.trim() === '') return;
    datDangLam(true);
    datLoi(null);
    try {
      await goi(`/api/giam-gia/${gg.id}`, {
        method: 'PATCH',
        than: { ten: ten.trim(), active, den: new Date(`${den}T23:59:59`).toISOString() },
      });
      xong(`Đã lưu "${ten.trim()}".`);
    } catch (e) {
      datLoi(e instanceof LoiApi ? e.message : 'Không lưu được.');
      datDangLam(false);
    }
  };

  return (
    <HopHoi
      tieuDe={`Sửa — ${gg.ten}`}
      nutY="Lưu"
      dangLam={dangLam}
      dong={dong}
      dongY={() => void luu()}
      choPhep={ten.trim() !== ''}
    >
      <DaiLoi loi={loi} />

      {/* Hiện phần ĐÔNG CỨNG ra ngay, dạng chỉ đọc — để quản lý không đi tìm chỗ sửa. */}
      <div className="lom-nho" style={{ padding: '14px 16px', marginBottom: 20, fontSize: 'var(--chu-nho)', lineHeight: 1.8 }}>
        <div style={{ fontWeight: 700, color: 'var(--chu)', marginBottom: 4 }}>Không sửa được</div>
        Kiểu: <b>{gg.kieu === 'PHAN_TRAM' ? 'Phần trăm' : 'Số tiền'}</b> · Giá trị:{' '}
        <b>{gg.kieu === 'PHAN_TRAM' ? `${gg.gia_tri}%` : tien(gg.gia_tri)}</b> · Phạm vi:{' '}
        <b>{gg.pham_vi === 'CA_DON' ? 'Cả đơn' : 'Theo sản phẩm'}</b> · Bắt đầu:{' '}
        <b>{ngay(gg.tu)}</b>
        <div style={{ color: 'var(--chu-3)', marginTop: 6 }}>
          Muốn đổi những thứ này thì tắt chương trình rồi tạo cái mới.
        </div>
      </div>

      <O nhan="Tên chương trình">
        <input value={ten} onChange={(e) => datTen(e.target.value)} />
      </O>
      <O nhan="Đến hết ngày">
        <input type="date" value={den} onChange={(e) => datDen(e.target.value)} />
      </O>
      <button
        onClick={() => datActive((c) => !c)}
        className={active ? undefined : 'lom-nho'}
        style={{ width: '100%', padding: 14, color: active ? undefined : 'var(--nhan)' }}
      >
        {active ? 'Đang bật — bấm để TẮT' : 'Đã tắt — bấm để bật lại'}
      </button>
    </HopHoi>
  );
}
